export enum ADMINS_ACTION_TYPE {
  LIST = 'admins/list',
  CREATE = 'admins/create',
  UPDATE = 'admins/update',
  DETAIL = 'admins/detail',
  DELETE = 'admins/delete',
  STATUS = 'admins/status',
}
